
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CLUser } from './user';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const UsersQuery = require('./gql/users.query.gql');
const UserQuery = require('./gql/user.query.gql');

const createCLUserMutation = require('./gql/create-user.mutation.gql');
const updateCLUserMutation = require('./gql/update-user.mutation.gql');
const deleteCLUserMutation = require('./gql/delete-user.mutation.gql');
const restoreCLUserMutation = require('./gql/restore-user.mutation.gql');

const resendCLEmailVerificationMutation = require('./gql/resend-email-verification.mutation.gql');

export interface CLUsersQueryResult {
  users: CLUser[]
  usersCount: number
}

export type CLUserOrderBy = 'USERNAME' | 'CREATED_AT';
export type CLUserOrderByDirection = 'ASC' | 'DESC';

export class CLUserFilter {
  offset: number
  limit: number

  search = '';
  orderBy: CLUserOrderBy = 'USERNAME';
  orderDir: CLUserOrderByDirection = 'ASC';
  deleted: boolean = false;
  account?: string;
}


@Injectable()
export class CLUserService {

  constructor(private apollo: Apollo) { }

  users(filter: CLUserFilter): Observable<CLUsersQueryResult> {
    return this.apollo
      .query({
        query: UsersQuery,
        variables: {
          filter
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        let items = result.data['clUsers']['items'];
        let total = result.data['clUsers']['total'];

        items = _map(items, item => new CLUser(item));

        return {
          users: items,
          usersCount: total,
        };
      }));
  }

  user(id: string): Observable<CLUser> {
    return this.apollo
      .query({
        query: UserQuery,
        variables: {
          id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => result.data['clUser'] ? new CLUser(result.data['clUser']) : null));
  }

  create(user: CLUser): Observable<CLUser> {
    return this.apollo
      .mutate({
        mutation: createCLUserMutation,
        variables: {
          input: user.toCreateCLUserInput()
        }
      }).pipe(
      map(result => new CLUser(result.data['createCLUser'])));
  }

  update(id: string, user: CLUser): Observable<CLUser> {
    return this.apollo
      .mutate({
        mutation: updateCLUserMutation,
        variables: {
          id,
          input: user.toUpdateCLUserInput()
        }
      }).pipe(
      map(result => new CLUser(result.data['updateCLUser'])));
  }

  delete(id: string): Observable<CLUser> {
    return this.apollo
      .mutate({
        mutation: deleteCLUserMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => new CLUser(result.data['deleteCLUser'])));
  }

  restore(id: string): Observable<CLUser> {
    return this.apollo
      .mutate({
        mutation: restoreCLUserMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => new CLUser(result.data['restoreCLUser'])));
  }

  resendEmailVerification(id: string, email: string): Observable<boolean> {
    return this.apollo
      .mutate({
        mutation: resendCLEmailVerificationMutation,
        variables: {
          input: {
            user: id,
            email,
          }
        }
      }).pipe(
      map(result => result.data['resendCLEmailVerification']));
  }
}

